<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        <span v-if="!reportIsMonth">داشبورد وضعیت سالیانه خرید</span>
        <span v-if="!reportIsMonth && goodsInfo"> {{ goodsInfo.Goods_Name }}</span>
        <span v-if="!reportIsMonth && goodsGroupInfo"> {{ goodsGroupInfo.Group_Name }}</span>
        <span v-if="reportIsMonth">داشبورد وضعیت ماهانه خرید مربوط به (ماه {{ parseInt(selectedMonth) }})</span>
        <span v-if="goodsInfo && reportIsMonth"> {{ goodsInfo.Goods_Name }}</span>
        <span v-if="goodsGroupInfo && reportIsMonth"> {{ goodsGroupInfo.Group_Name }}</span>
        <template v-slot:action>
          <q-btn v-if="reportIsMonth" icon="arrow_back" flat round @click="baseReport"/>
          <q-btn icon="settings" flat round @click="filterDialog=true"/>
          <q-btn v-if="isDialog" icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="(goodsInfo || goodsGroupInfo) && suppliers
    && $store.state.roles.some(v=>['admin','can_see_goods_suppliers'].includes(v))">
      <span class="text-h5">تامین کنندگان </span>
      <q-space/>
      <q-chip square :size="$q.screen.lt.md?'sm':'md'" v-for="(item, index) in suppliers"
              clickable
              :key="index" :label="item.Cs_Name" icon="person"
              @click="showSupplierInfo(item)"/>
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <apexchart ref="chart" type="bar" width="100%" height="900vw" :options="chartOptions"
                 :series="series"/>
    </q-card-section>
    <q-dialog v-model="filterDialog" :maximized="$q.screen.lt.md">
      <q-card flat :style="!$q.screen.lt.md?'width:600px':''">
        <q-card-section class="no-padding">
          <q-banner class="bg-primary text-white" inline-actions>
            پارامترهای جستجو
            <template v-slot:action>
              <q-btn icon="close" round flat v-close-popup/>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section>
          <q-select
              :dense="$q.screen.lt.md"
              v-model="selectedReportType"
              :options="reportTypes"
              option-label="title"
              option-value="id"
              label="نوع گزارش"
          />
          <q-select
              :dense="$q.screen.lt.md"
              v-model="selectedYear"
              :options="lodash.orderBy(years, '[year]', 'desc')"
              option-label="year"
              option-value="year"
              label="سال گزارش"
          />
          <q-select
              :dense="$q.screen.lt.md"
              multiple
              v-model="selectedCompany"
              :options="companiesList"
              option-label="CompName"
              option-value="CompID"
              use-chips
              label="شرکت"
          />
          <q-select
              v-model="selectedStates"
              label="استان"
              :options="statesOptions"
              option-label="State_Name"
              option-value="State_ID"
              @filter="filterFn"
              use-chips
              use-input
              multiple
          />
          <q-select
              v-model="selectedCities"
              label="شهر"
              :options="citiesOptions"
              option-label="City_Name"
              option-value="City_ID"
              @filter="filterFnCity"
              use-chips
              use-input
              multiple
          />
          <q-select
              v-model="selectedGoodsGroup"
              label="گروه کالا"
              :options="goodsGroupOptions"
              option-label="Group_Name"
              option-value="Group_ID"
              @filter="filterGoodsGroupFn"
              use-chips
              use-input
              multiple
          />
          <q-select
              v-model="selectedGoods"
              label="کالا"
              :options="goodsOptions"
              option-label="Goods_Name"
              option-value="Goods_ID"
              @filter="filterGoodsGroupFn"
              use-chips
              use-input
              multiple
          />
          <q-select
              :dense="$q.screen.lt.md"
              multiple
              v-model="selectedUsers"
              :options="usersList"
              option-label="UserName"
              option-value="Users_ID"
              use-chips
              label="کاربران ثبت کننده"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="supplierInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :buy-list="true" :dialog="true" :selected-customer="selectedSupplier"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo.vue";

export default {
  name: "BuyYearlyDashboard",
  components: {CustomerInfo},
  props: {
    goodsInfo: {
      type: Object,
      default: undefined
    },
    goodsGroupInfo: {
      type: Object,
      default: undefined
    },
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      suppliers: [],
      reportIsMonth: false,
      selectedMonth: -1,
      filterDialog: false,
      items: [],
      selectedGoods: [],
      selectedStates: [],
      selectedCities: [],
      states: [],
      statesOptions: [],
      cities: [],
      citiesOptions: [],
      selectedCompany: [],
      selectedUsers: [],
      selectedYear: this.ToJalaliDate(new Date()).substring(0, 4),
      selectedGoodsGroup: [],
      years: [],
      series: [],
      companiesList: [],
      usersList: [],
      goodsGroup: [],
      goodsGroupOptions: [],
      goods: [],
      goodsOptions: [],
      selectedReportType: {id: 1, title: "گزارش ریالی"},
      reportTypes: [
        {id: 1, title: "گزارش ریالی"},
        {id: 2, title: "گزارش تعدادی"}
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          dir: 'rtl',
          fontFamily: "IRANSans, sans-serif",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (!this.reportIsMonth) {
                this.reportIsMonth = true
                this.selectedMonth = parseInt(config.dataPointIndex) + 1
                this.LoadAllMonthData()
              }
            }
          },
        },
        theme: {
          palette: 'palette7' // upto palette10
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: true,
            radiusOnLastStackedBar: true
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
          labels: {
            show: false,
            formatter: function (val) {
              return val
            }
          }
        },
        yaxis: {
          title: {
            text: undefined
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toLocaleString();
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return value.toLocaleString();
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
        }
      },
      selectedSupplier: undefined,
      supplierInfoDialog: false
    }
  },
  methods: {
    ...mapActions({
      LoadData: 'Buys/getBuyReportYearly',
      LoadMonthlyData: 'Buys/getBuyMonthlyInYearData',
      LoadFilterData: 'Dashboard/getYearlyFilterData',
      setCitiesList: 'Customers/getCity',
      getGoodsList: 'Products/getGoodsList',
      getGoodsSuppliers: 'Products/getGoodsSuppliers',
      getGoodsGroupSuppliers: 'Products/getGoodsGroupSuppliers',
      getCustomerInfo: 'Customers/get_customer_info'
    }),
    showSupplierInfo(supplierInfo) {
      this.getCustomerInfo(supplierInfo.Cs_ID).then((res) => {
        this.selectedSupplier = res.data[0]
        this.supplierInfoDialog = true
      })
    },
    baseReport() {
      this.selectedMonth = -1
      this.reportIsMonth = false
      this.LoadAllData()
    },
    filterFn(val, update) {
      update(() => {
        this.statesOptions = this.states.filter(item => item.State_Name.includes(val))
      })
    },
    filterFnCity(val, update) {
      update(() => {
        this.citiesOptions = this.cities.filter(item => item.City_Name.includes(val))
      })
    },
    filterGoodsGroupFn(val, update) {
      update(() => {
        this.goodsGroupOptions = this.goodsGroup.filter(item => item.Group_Name.includes(val))
      })
    },
    async LoadAllData() {
      await this.LoadData({
        selectedCompany: this.selectedCompany,
        selectedUsers: this.selectedUsers,
        selectedYear: this.selectedYear.year,
        selectedGoodsGroup: this.goodsGroupInfo === undefined ? this.selectedGoodsGroup : [this.goodsGroupInfo],
        selectedStates: this.selectedStates,
        selectedCities: this.selectedCities,
        selectedGoods: this.goodsInfo === undefined ? this.selectedGoods : [this.goodsInfo]
      }).then((res) => {
        this.items = res.data;
        let i = 0;
        for (i = 1; i <= 12; i++) {
          const existsSales = this.items.filter(item => item.Ty === 'سفارش نهایی' && item.Month === i).length > 0
          const existsFactor = this.items.filter(item => item.Ty === 'فاکتور' && item.Month === i).length > 0

          if (!existsSales) {
            this.items.push({Month: i, Sum_Sale_Count: 0, Sum_Sale_Pay: 0, Ty: 'سفارش نهایی'})
          }
          if (!existsFactor) {
            this.items.push({Month: i, Sum_Sale_Count: 0, Sum_Sale_Pay: 0, Ty: 'فاکتور'})
          }
        }
        this.chartOptions = {
          xaxis: {
            categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            labels: {
              show: false,
              formatter: function (val) {
                return val
              }
            }
          },
        }
        this.series = [
          {
            name: 'سفارش نهایی',
            data: this.lodash.orderBy(this.items.filter(item => item.Ty === 'سفارش نهایی'), ['Month']).map(item => this.selectedReportType.id === 1 ? item.Sum_Sale_Pay : item.Sum_Sale_Count)
          },
          {
            name: 'فاکتور',
            data: this.lodash.orderBy(this.items.filter(item => item.Ty === 'فاکتور'), ['Month']).map(item => this.selectedReportType.id === 1 ? item.Sum_Sale_Pay : item.Sum_Sale_Count)
          }
        ]
      })

      if (this.goodsInfo) {
        await this.getGoodsSuppliers(this.goodsInfo.Goods_ID).then((res) => {
          this.suppliers = res
        })
      }

      if (this.goodsGroupInfo) {
        await this.getGoodsGroupSuppliers(this.goodsGroupInfo.Group_ID).then((res) => {
          this.suppliers = res
        })
      }
    },
    async LoadAllMonthData() {
      await this.LoadMonthlyData({
        selectedCompany: this.selectedCompany,
        selectedUsers: this.selectedUsers,
        selectedYear: this.selectedYear.year,
        selectedGoodsGroup: this.goodsGroupInfo === undefined ? this.selectedGoodsGroup : [this.goodsGroupInfo],
        selectedStates: this.selectedStates,
        selectedCities: this.selectedCities,
        selectedGoods: this.goodsInfo === undefined ? this.selectedGoods : [this.goodsInfo],
        DayOfMonth: this.selectedMonth
      }).then((res) => {
        this.items = res;
        const localItems = []
        for (let i = 1; i <= 30; i++) {
          localItems.push({Month: i, Sum_Sale_Count: 0, Sum_Sale_Pay: 0, Ty: 'سفارش نهایی'})
          localItems.push({Month: i, Sum_Sale_Count: 0, Sum_Sale_Pay: 0, Ty: 'فاکتور'})
        }
        for (let i = 1; i <= 30; i++) {
          const existsSales = this.items.filter(item => item.Ty === 'سفارش نهایی' && item.DayOfMonth === i)
          const existsFactor = this.items.filter(item => item.Ty === 'فاکتور' && item.DayOfMonth === i)

          if (existsSales && existsSales.length > 0) {
            const founded = localItems.filter(item => item.Ty === 'سفارش نهایی' && item.Month === i)
            if (founded && founded.length > 0) {
              founded[0].Sum_Sale_Count = existsSales[0].Sum_Sale_Count
              founded[0].Sum_Sale_Pay = existsSales[0].Sum_Sale_Pay
            }
          }

          if (existsFactor && existsFactor.length > 0) {
            const founded = localItems.filter(item => item.Ty === 'فاکتور' && item.Month === i)
            if (founded && founded.length > 0) {
              founded[0].Sum_Sale_Count = existsFactor[0].Sum_Sale_Count
              founded[0].Sum_Sale_Pay = existsFactor[0].Sum_Sale_Pay
            }
          }
        }
        this.items = localItems
        this.chartOptions = {
          xaxis: {
            categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
            labels: {
              show: false,
              formatter: function (val) {
                return val
              }
            }
          },
        }
        this.series = [
          {
            name: 'سفارش نهایی',
            data: this.lodash.orderBy(this.items.filter(item => item.Ty === 'سفارش نهایی'), ['Month']).map(item => this.selectedReportType.id === 1 ? item.Sum_Sale_Pay : item.Sum_Sale_Count)
          },
          {
            name: 'فاکتور',
            data: this.lodash.orderBy(this.items.filter(item => item.Ty === 'فاکتور'), ['Month']).map(item => this.selectedReportType.id === 1 ? item.Sum_Sale_Pay : item.Sum_Sale_Count)
          }
        ]
      })
    }
  },
  watch: {
    selectedCompany: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedUsers: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedYear: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedReportType: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedGoodsGroup: function (val) {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
      if (val && val.length > 0) {
        this.getGoodsList({goodsGroup: val, selectedStore: []}).then((res) => {
          this.goods = res;
          this.goodsOptions = this.goods;
        })
      }
    },
    selectedStates: function (val) {
      if (val && val.length > 0) {
        this.setCitiesList(val.map(item => item.State_ID).join(',')).then((res) => {
          this.cities = res;
          this.citiesOptions = res;
        })
      }
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedCities: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    },
    selectedGoods: function () {
      if (!this.reportIsMonth) {
        this.LoadAllData()
      } else {
        this.LoadAllMonthData()
      }
    }
  },
  created() {
    this.LoadFilterData().then((res) => {
      this.companiesList = JSON.parse(res.companies)
      this.usersList = JSON.parse(res.users)
      this.years = JSON.parse(res.available_years)
      this.goodsGroup = eval(res.goodsGroup)
      this.goodsGroupOptions = this.goodsGroup
      this.states = eval(res.states)
      this.statesOptions = this.states
      this.LoadAllData()
    })
  }
}
</script>

<style scoped>

</style>
